module.exports = __webpack_public_path__ + "static/media/motorcycle.1768ad70.png";